import React from 'react';
import { Skeleton } from '../ui/Skeleton';

export default function SkeletonSitesList() {
  return (
    <div className="px-8 py-8 max-w-6xl mx-auto animate-pulse">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <Skeleton className="h-7 w-24" rounded="rounded" />
        <div className="ml-auto">
          <Skeleton className="h-9 w-32" rounded="rounded-lg" />
        </div>
      </div>

      {/* Search bar */}
      <div className="mb-6">
        <Skeleton className="h-9 w-72" rounded="rounded-lg" />
      </div>

      {/* Table header */}
      <div className="grid grid-cols-[1fr_140px_140px_44px] items-center px-4 pb-2 border-b border-gray-200 dark:border-gray-700">
        <Skeleton className="h-3 w-12" rounded="rounded" />
        <Skeleton className="h-3 w-16" rounded="rounded" />
        <Skeleton className="h-3 w-12" rounded="rounded" />
        <div />
      </div>

      {/* Table rows */}
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="grid grid-cols-[1fr_140px_140px_44px] items-center px-4 py-3 border-b border-gray-100 dark:border-gray-700/50">
          <div className="flex items-center gap-4">
            <Skeleton className="w-[100px] h-[64px] flex-shrink-0" rounded="rounded-md" />
            <div>
              <Skeleton className="h-4 w-36 mb-1.5" rounded="rounded" />
              <Skeleton className="h-3 w-24" rounded="rounded" />
            </div>
          </div>
          <Skeleton className="h-3 w-20" rounded="rounded" />
          <Skeleton className="h-5 w-16" rounded="rounded-full" />
          <Skeleton className="h-6 w-6" rounded="rounded" />
        </div>
      ))}
    </div>
  );
}
